import { SoftphoneIntegrationEnum, TimeEnum } from '@lib/enums';

import type { AppConfig } from '@config';

export const DevConfig = {
  apiKeyGoogleMaps: 'AIzaSyB6aRjr-BiiOP2tPG4OLlcLmDl73NfhzXw',
  appEnv: 'development',
  azure: {
    appInsightsConnectionString:
      'InstrumentationKey=30fb14a3-1515-422b-867a-f87f71719195;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/',
    appInsightsKey: '30fb14a3-1515-422b-867a-f87f71719195',
    authority: 'https://login.microsoftonline.com/daae7bc1-c893-46c4-8df4-4464a9a6f43e',
    clientId: '1ffc00d1-10a4-4e76-8840-912239b05fee',
    tenantId: 'daae7bc1-c893-46c4-8df4-4464a9a6f43e',
  },
  gatewayUrl: 'https://end-gateway-kitt-dev.azurewebsites.net/api/v1',
  paymentUrl: 'https://enduipaymentkittdev-f6axdph2fjf7d7ck.z01.azurefd.net/',
  pcrsPortalUrl: 'https://uat-beta-auto.pcrsdev.com/pcmi.web.portal.core',
  softphoneIntegration: {
    client: SoftphoneIntegrationEnum.Contacts,
    enabled: true,
    enableDebugLogs: true,
  },
  defaultApiTimeout: TimeEnum.ThirtySeconds,
  sentryIngestionEndpoint:
    'https://4c7389d417facfc54fc63ce40581895a@o4506672688791552.ingest.sentry.io/4506672696393728',
} satisfies AppConfig;
